import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SparklineComponent } from './components/sparkline/sparkline.component';
import { VectormapComponent } from './components/vectormap/vectormap.component';
import { RemoteApiService } from './services/remote-api.service';
import { JqmeterBarComponent } from './components/jqmeter-bar/jqmeter-bar.component';
import { CirclesComponent } from './components/circles/circles.component';
import { DcalendarComponent } from './components/dcalendar/dcalendar.component';
import { FilterPipe } from './pipes/filter.pipe';
import { MatListModule } from '@angular/material/list';
import { EditingTextComponent } from './components/UI-components/editing-text/editing-text.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TemplateVariableFormatPipe } from './pipes/template-variable-format.pipe';
import { FormUploadMultipleComponent } from './components/UI-components/formUpload/form-upload-multiple/form-upload-multiple.component';
import { SortCustomPipe } from './pipes/sort-custom.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { UploadFileService } from './components/UI-components/formUpload/upload-file.service';
import { FormUploadMultipleReplyComponent } from './components/UI-components/formUpload/form-upload-multiple-reply/form-upload-multiple-reply.component';
import { FormUploadComponent } from './components/UI-components/formUpload/form-upload/form-upload.component';
import { FormUploadVideoComponent } from './components/UI-components/formUpload/form-upload/form-upload-video/form-upload-video.component';
import { MatIconModule } from '@angular/material/icon';
import { FollowUpFormUploadComponent } from './components/UI-components/formUpload/follow-up-form-upload/follow-up-form-upload.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { AlphabeticalSortPipe } from './pipes/alphabeticalSort.pipe';
import { StoresService } from './services/stores.service';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { PlanGuard } from '../core/guards/Plan.guard';
import { DropdownResponsesComponent } from './components/UI-components/dropdownResponses/dropdownResponses.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NewlinePipe } from './pipes/newline.pipe';
import { LoggingService } from './services/Logging.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { LoadingSpinnerComponent } from './components/UI-components/loading-spinner/loading-spinner.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationContainerComponent } from './notification-container/notification-container.component';
import { InviteUserDialogComponent } from './components/invite-user-dialog/invite-user-dialog.component';
import { ContactUsDialogComponent } from './components/contact-us-dialog/contact-us-dialog.component';
import { GuideTooltipComponent } from '../guide-tooltip/guide-tooltip.component';
import { OnboardingTourComponent } from './components/onboarding-tour/onboarding-tour.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    VectormapComponent,
    SparklineComponent,
    JqmeterBarComponent,
    CirclesComponent,
    DcalendarComponent,
    FilterPipe,
    EditingTextComponent,
    TemplateVariableFormatPipe,
    FormUploadMultipleComponent,
    SortCustomPipe,
    CustomDatePipe,
    FormUploadMultipleReplyComponent,
    FormUploadComponent,
    FormUploadVideoComponent,
    FollowUpFormUploadComponent,
    AlphabeticalSortPipe,
    ConfirmDialogComponent,
    SafeUrlPipe,
    DropdownResponsesComponent,
    NewlinePipe,
    NotificationComponent,
    NotificationContainerComponent,
    InviteUserDialogComponent,
    ContactUsDialogComponent,
    GuideTooltipComponent,
    OnboardingTourComponent,
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatInputModule,
    MatIconModule,
    OverlayModule,
    HttpClientModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    PickerModule,
    MatProgressSpinnerModule,
    LoadingSpinnerComponent,
  ],
  providers: [
    RemoteApiService,
    UploadFileService,
    StoresService,
    PlanGuard,
    LoggingService,
  ],
  exports: [VectormapComponent, SparklineComponent, JqmeterBarComponent, CirclesComponent,
    DcalendarComponent, FilterPipe, EditingTextComponent, TemplateVariableFormatPipe, FormUploadMultipleComponent,
    SortCustomPipe, CustomDatePipe, FormUploadMultipleReplyComponent, FormUploadComponent, FormUploadVideoComponent, NotificationContainerComponent,
    FollowUpFormUploadComponent, AlphabeticalSortPipe, SafeUrlPipe, DropdownResponsesComponent, NewlinePipe, LoadingSpinnerComponent, NotificationComponent, MatSlideToggleModule, GuideTooltipComponent, GuideTooltipComponent,
  MatIconModule, ConfirmDialogComponent, OnboardingTourComponent,],
})
export class SharedModule { }
